// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy, mockSpecifiedItems } from './shared';

export const label = 'Buildings - Full AD';

export const policy: Policy = createMockPolicy({
  policyNumber: 'B21/0639200',
  policyDetailsId: '123445667900',
  coverType: 'Buildings',
  accidentalDamageLevel: { Buildings: 'Full', Contents: 'None' },
  specifiedItems: mockSpecifiedItems
});
